<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { notify } from '@/helpers/notify' 

export default {
    page: {
    title: "TARİFE EŞLEME",
    meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader
    },
    data(){
        return {
            loading:true,
            title: "TARİFE EŞLEME",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "TARİFE EŞLEME",
                    active: true,
                },
            ],
            form:{
                tarife_turu:''
            },
            projectData: [],
            telekomList: [],
            ispList: [],
            loadingTelekom:false,
        }
    },
    mounted(){
      const clientHeight = document.getElementsByClassName('page-content')[0].clientHeight;
      document.getElementsByClassName('table-responsive')[0].style.minHeight = clientHeight + 'px'
      this.getList()
    },
    methods:{
      getList(){
        this.$http.post(`/vae/tariff`)
          .then(resp => {
              this.projectData = resp.data
          })
          .catch(error => error)
          .finally(() => this.dataLoading=false)
      },
      edit(params){
        this.form = { ...params }
      },
      save(){
        this.$http.post(`/vae/tariff/store`, { ...this.form })
        .then(() => {
           this.form = {}
           this.getList()
        })
        .catch(error => error)
        .finally(() => this.dataLoading=false)
      },
      remove({id}){
        this.$http.delete('/vae/tariff/' + id)
          .then(resp => {
            if(resp.data.code !==  100)  return notify.error(resp.data.message)
            this.getList()
            return notify.success(resp.data.message)
          })
          .catch(error => error)
      },
      tariff({target}){
        this.loadingTelekom = true;
        this.telekomList = [];
        this.ispList = [];
        this.$http.post(`/vae/tariff/getTelekom`, { type:target.value })
        .then((response) => { 
          if(response.data.error) return notify.error(response.data.message)
          this.telekomList = response.data.content
          this.telekomList.sort((a,b) => (a.paketAdi > b.paketAdi) ? 1 : ((b.paketAdi > a.paketAdi) ? -1 : 0))
        })
        .catch(error => error)
        .finally(() => this.loadingTelekom=false)

        var targetValue = ""
        switch (target.value) {
          case "1":
            targetValue = "ADSL"
            break;
          case "6":
            targetValue = "VDSL"
            break;
          case "7":
            targetValue = "FIBER"
            break;
        }
        this.$http.post(`/tariff/getByGroup`, { groupName:targetValue,output:'only' })
        .then((response) => { 
            this.ispList = response.data.content
        })
        .catch(error => error)
        .finally(() => this.dataLoading=false)
      }
    }
    
}
</script>
<template>
 <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div>
          <div class="table-responsive">
            <table
              class="table project-list-table  table-centered table-borderless align-middle"
            >
              <thead>
                <tr>
                  <th scope="col" style="width:10%">Tarife Türü</th>
                  <th scope="col" style="width:40%">Telekom Tarifeleri</th>
                  <th scope="col" style="width:40%">Sizin Tarifeleriniz</th>
                  <th scope="col" ></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                    <td>
                        <select 
                            class="form-select form-select-sm"  
                            v-model="form['tarife_turu']" 
                            @change="tariff($event)">
                            <option value="">Seçiniz</option>
                            <option value="1">ADSL</option>
                            <option value="6">VDSL</option>
                            <option value="7">Fiber</option>
                      </select>
                    </td>
                    <td>
                      <v-select
                            :loading="loadingTelekom"
                            label="paketAdi" 
                            v-model="form.telekom"
                            :options="telekomList">
                            <span slot="no-options">Sonuç Bulunamadı</span>
                            <template #spinner="{ loading }">
                              <div
                                v-if="loading"
                                style="border-left-color: rgba(88, 151, 251, 0.71)"
                                class="vs__spinner"
                              >
                                The .vs__spinner class will hide the text for me.
                              </div>
                            </template>
                        </v-select>
                    </td>
                    <td>
                        <v-select
                            label="name" 
                            v-model="form.isp"
                            :options="ispList" 
                            :reduce="df => df.id">
                            <span slot="no-options">Sonuç Bulunamadı</span>
                        </v-select>
                    </td>
                    <td>
                        <button 
                            v-if="form.id"
                            @click="update()" 
                            class="btn btn-warning">
                            Güncelle
                        </button>
                         <button 
                            v-else
                            @click="save()" 
                            class="btn btn-primary">
                            Ekle
                        </button>
                    </td>
                </tr>
                <tr v-if="projectData.length == 0">
                  <td colspan=4 class="text-center">Kayıt Bulunmamaktadır</td>
                </tr>
                <tr v-for="project in projectData" :key="project.id">
                  <td>{{ project.type }}</td>
                  <td>
                    <h5 class="text-truncate font-size-14">
                     {{ project.name }}
                    </h5>
                  </td>
                  <td>{{ project.tariff_name }}</td>
                 <td>
                    <b-dropdown
                      class="card-drop"
                      variant="white"
                      menu-class="dropdown-menu-end"
                      right
                      toggle-class="p-0"
                    >
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>
                      <b-dropdown-item href="javascript: void(0);"
                        @click="remove(project)"
                        >Sil</b-dropdown-item
                      >
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>